module.exports = __webpack_public_path__ + "img/howto_insurancestaking_approvecontract.ac444430.png";